import { useState } from 'react';

import { Route, Routes } from 'react-router-dom';

import { parseErrorMessageFromPointerDE } from '../../../helpers/parseErrorMessageFromPointer/parseErrorMessageFromPointerDE';
import { useCurrentStep } from '../../../hooks/useCurrentStep';
import { OffersDEProvider } from '../../../hooks/useOffers/useOffersDE';
import { useSignup } from '../../../hooks/useSignup';
import { TStateUpdateErrorDE } from '../../../types';
import CompanyDetailsDE from '../../CompanyDetails/CompanyDetailsDE/CompanyDetailsDE';
import GetStartedDE from '../../GetStarted/GetStartedDE/GetStartedDE';
import PersonalDetailsDE from '../../PersonalDetails/PersonalDetailsDE/PersonalDetailsDE';
import RouteSpinner from '../../RouteSpinner/RouteSpinner';
import TradingHistoryWithOffersCheckDE from '../../TradingHistory/TradingHistoryDE/TradingHistoryWithOffersCheckDE';
import StateErrorModal from '../StateErrorModal/StateErrorModal';

const SignupRoutesDE = () => {
  const [stateError, setStateError] = useState<TStateUpdateErrorDE>(null);

  const { isLoading, hasAllData } = useSignup();
  const currentStep = useCurrentStep();

  const stepIsNewOrLoading =
    (isLoading || !hasAllData) && currentStep !== 'neu';

  if (stepIsNewOrLoading) {
    return <RouteSpinner />;
  }

  const handleStateUpdateError = (error: Error) => {
    const errorMessage = parseErrorMessageFromPointerDE(error);
    setStateError(errorMessage);
  };

  return (
    <>
      <Routes>
        <Route
          path="/neu"
          element={
            <GetStartedDE handleStateUpdateError={handleStateUpdateError} />
          }
        />
        <Route
          path="/schritt-1"
          element={
            <CompanyDetailsDE handleStateUpdateError={handleStateUpdateError} />
          }
        />
        <Route
          path="/schritt-2"
          element={
            <PersonalDetailsDE
              handleStateUpdateError={handleStateUpdateError}
            />
          }
        />
        <Route
          path="/schritt-3"
          element={
            <OffersDEProvider>
              <TradingHistoryWithOffersCheckDE />
            </OffersDEProvider>
          }
        />
        {/* Fallback route */}
        <Route path="/*" element={<RouteSpinner />} />
      </Routes>
      <StateErrorModal
        stateError={stateError}
        handleClose={() => setStateError(null)}
      />
    </>
  );
};

export default SignupRoutesDE;
